// extracted by mini-css-extract-plugin
module.exports = {"linkHeader":"Teams_linkHeader__ZmwZM","siteIcon":"Teams_siteIcon__2HL1U","active":"Teams_active__3UpsS"};